import { Box, BoxProps, Button, ButtonProps } from "@chakra-ui/react";

type CollapseToggleIconProps = BoxProps & {
  collapsedOffsetDegrees?: number;
  expandedOffsetDegrees?: number;
};

export function CollapseToggleIcon({
  collapsedOffsetDegrees,
  expandedOffsetDegrees = collapsedOffsetDegrees,
  ...rest
}: CollapseToggleIconProps) {
  return (
    <Box
      as="span"
      display="inline-block"
      lineHeight={2}
      transition="transform 200ms"
      transform={
        collapsedOffsetDegrees
          ? `rotate(${collapsedOffsetDegrees}deg)`
          : undefined
      }
      sx={{
        "[aria-expanded=true] > &, [aria-expanded=true] > .chakra-button__icon > & ":
          {
            transform: `rotate(${-((expandedOffsetDegrees || 0) + 90)}deg)`,
          },
      }}
      {...rest}
    >
      &#9664;&#xfe0e;
    </Box>
  );
}

type Props = ButtonProps & {
  controlsId?: string;
  isExpanded?: boolean;
  onExpandedChange?: (isExpanded: boolean) => void;
};

export default function CollapseToggleButton({
  children = <CollapseToggleIcon />,
  controlsId,
  isExpanded,
  onClick,
  onExpandedChange,
  ...rest
}: Props) {
  return (
    <Button
      {...rest}
      onClick={(evt) => {
        onClick?.(evt);
        onExpandedChange?.(!isExpanded);
      }}
      aria-controls={controlsId}
      aria-expanded={isExpanded}
    >
      {children}
    </Button>
  );
}
